// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@guestsupply/XDL/types";
import { color, ellipsis, getSystemColor } from "@guestsupply/XDL/Utilities";
import { FormFieldClickable, FormFieldIcon } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

const PlaceholderSelector = `
        &::placeholder,
        &::-webkit-input-placeholder
`;

export const placeholderStyle = css`
    ${PlaceholderSelector} {
        font-size: 14px;
        letter-spacing: 0;
        line-height: 16px !important;
        max-width: 100%;
        color: ${getSystemColor("common.ui4")};
        font-weight: 400;
    }
`;

export default {
    defaultProps: {
        mergeCss: true,
        border: "rectangle",
        sizeVariant: "default",
        backgroundColor: "common.ui1",
        labelProps: {
            mergeCss: true,
            size: 12,
            transform: "capitalize",
            weight: 500,
            color: "text",
            css: css`
                min-height: initial;
                letter-spacing: 0;
                line-height: 15px;
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 13,
            weight: 400,
            color: "danger.main",
            css: css`
                min-height: initial;
                letter-spacing: 0;
                line-height: 20px;
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                input,
                textarea,
                select {
                    &:not(.react-datetime-picker__inputGroup__input) {
                        ${placeholderStyle}
                        &:disabled {
                            ${PlaceholderSelector} {
                                color: ${color("text.main")};
                            }
                        }
                        &:not(:disabled):not(:focus):hover {
                            border: 1px solid ${color("common.ui8")};
                        }
                    }
                }
                ${FormFieldClickable} {
                    &:hover {
                        ${FormFieldIcon} {
                            color: ${color("common.ui8")};
                        }
                    }
                }
                input,
                select {
                    &:not(.react-datetime-picker__inputGroup__input) {
                        ${ellipsis(1)}
                        text-overflow: ellipsis;
                        /* Styles for Safari only */
                        @media not all and (min-resolution: 0.001dpcm) {
                            -webkit-line-clamp: unset;
                        }
                    }
                }
                input,
                textarea {
                    box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.1)};
                    resize: none;
                }

                &[data-size="large"] {
                    && input {
                        padding: 0 16px 0 16px;
                    }

                    && ${IconWrapper} {
                        padding: 10px;
                    }
                }
            `,
        },
    },
} as xBaseTheme["formField"];
